export default function LinkIcon({ width = '34', height = '35' }) {
  return (
    <svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.0559082" width="34" height="34" rx="17" fill="#FAB23D" />
      <path
        d="M7.21667 16.8333C7.21667 14.8383 8.83833 13.2167 10.8333 13.2167H15.5V11H10.8333C7.61333 11 5 13.6133 5 16.8333C5 20.0533 7.61333 22.6667 10.8333 22.6667H15.5V20.45H10.8333C8.83833 20.45 7.21667 18.8283 7.21667 16.8333ZM12 18H21.3333V15.6667H12V18ZM22.5 11H19.667V13.2167H22.5C24.495 13.2167 26.1167 14.8383 26.1167 16.8333C26.1167 18.8283 24.495 20.45 22.5 20.45H19.667V22.6667H22.5C25.72 22.6667 28.3333 20.0533 28.3333 16.8333C28.3333 13.6133 25.72 11 22.5 11Z"
        fill="black"
      />
    </svg>
  )
}
